A date string compliant with the ISO 8601 "year", "year and month" or "complete date" formats.

For example, `"2020"`, `"2020-05"` and `"2020-05-27"` are all valid for `HistoryDate`.

This is used for dates in a candidate's position & employment histories where the precise month or day may not have been provided.
